<div class="dashboard-filter-header">
    <div class="top-split">
        <span class="db-name">{{dashboardName}}</span>
        <div class="right-split">
            <div *ngIf="this.unitSelected==='cost' || unitSelected === 'wastePer'" class="legend-cntnr fh">
                <div class="legend total-waste fh">
                    <mat-checkbox [(ngModel)]="showData.total" (change)="filterChange()"
                        [disabled]="showData.total && !showData.RM && !showData.PM">
                        {{'common.total_waste' | translate}}
                    </mat-checkbox>
                </div>
                <div class="legend raw-material-waste fh">
                    <mat-checkbox [(ngModel)]="showData.RM" (change)="filterChange()"
                        [disabled]="!showData.total && showData.RM && !showData.PM">
                        {{'common.rm_waste' | translate}}
                    </mat-checkbox>
                </div>
                <div class="legend package-material-waste fh">
                    <mat-checkbox [(ngModel)]="showData.PM" (change)="filterChange()"
                        [disabled]="!showData.total && !showData.RM && showData.PM">
                        {{'common.pm_waste' | translate}}
                    </mat-checkbox>
                </div>
            </div>

            <div class="legend-cntnr fh waste-line" *ngIf="this.unitSelected==='quantity'">
                <div class="legend raw-material-waste fh">
                    <mat-checkbox [(ngModel)]="showData.RM" (change)="filterChange()"
                        [disabled]="showData.RM && !showData.PM">
                        {{'common.rm_waste' | translate}}
                    </mat-checkbox>
                </div>
                <div class="legend package-material-waste fh">
                    <mat-checkbox [(ngModel)]="showData.PM" (change)="filterChange()"
                        [disabled]="!showData.RM && showData.PM">
                        {{'common.pm_waste' | translate}}
                    </mat-checkbox>
                </div>
            </div>

            <div class="time-period-selector" matRipple (click)="showTimePicker=true"
                (keydown.enter)="showTimePicker=true" (keydown.space)="showTimePicker=true">

                <span *ngIf="currrentFilter === 'month'">
                    {{currentDate | date : "MMMM" | translate}} {{currentDate | date : "yyyy"}}
                </span>
                <span *ngIf="currrentFilter === 'week' && filterApplied">
                    {{currentDate | date : "dd"}}/{{currentDate | date : "MMM" | translate}}/{{currentDate | date :
                    "yyyy"}} -
                    {{currentEndWeek - 1 | date : "dd"}}/{{currentEndWeek - 1 | date : "MMM" |
                    translate}}/{{currentEndWeek - 1 | date : "yyyy"}}
                </span>
                <span *ngIf="currrentFilter === 'date' && filterApplied">
                    {{currentDate | date : "dd"}}/{{currentDate | date : "MMM" | translate}}/{{currentDate | date :
                    "yyyy"}}
                </span>
                <span *ngIf="currrentFilter === 'shift' && filterApplied">
                    {{currentDate | date : "dd"}}/{{currentDate | date : "MMM" | translate}}/{{currentDate | date :
                    "yyyy"}}, Shift
                    {{currentShift.shift}}</span>
                <span *ngIf="currrentFilter === 'hour' && filterApplied">
                    {{currentDate | date : "dd"}}/{{currentDate | date : "MMM" | translate}}/{{currentDate | date :
                    "yyyy"}},
                    {{currentHour}}</span>

                <div class="arrow-down"></div>
            </div>
            <div class="funnel" matRipple (click)="openDialog()" (keydown.enter)="openDialog()"
                (keydown.space)="openDialog()">
                <img class="funnel-img" alt="Filter-icon" src="../../../../assets/images/funnel_filter.svg" />
            </div>
        </div>
    </div>
    <div class="bottom-split">
        <div class="db-granularity-split" *ngIf="granularityBreadCrumb?.length">
            <span class="label">{{'common.visualization' | translate}}:</span>
            <span class="link" [class.last]="last" *ngFor="let item of granularityBreadCrumb;let last=last;">
                <span class="link-text" (click)="granularityClick(item)" (keydown.enter)="granularityClick(item)"
                    (keydown.space)="granularityClick(item)" *ngIf="item?.label==='All'"> {{'common.all' | translate}}
                </span>
                <span class="link-text" (click)="granularityClick(item)" (keydown.enter)="granularityClick(item)"
                    (keydown.space)="granularityClick(item)" *ngIf="item?.label!=='All'"> {{item?.label}} </span>
                <span class="gt">&gt;</span> </span>
        </div>
        <span *ngIf="item?.label==='All'"> {{'common.all' | translate}} </span>
        <div class="splitter" *ngIf="granularityBreadCrumb?.length && detailBreadcrumb?.length"></div>

        <div class="db-detail-split" *ngIf="detailBreadcrumb?.length">
            <span class="label">{{'common.detail' | translate}}:</span>
            <span class="link" *ngFor="let item of detailBreadcrumb;let i = index">
                <span (click)="detailClick(item)" (keydown.enter)="detailClick(item)"
                    (keydown.space)="detailClick(item)" [ngClass]="{'detail-link-text':i===0}"
                    *ngIf="item?.label==='All'"> {{'common.all' | translate}} </span>
                <span (click)="detailClick(item)" (keydown.enter)="detailClick(item)"
                    (keydown.space)="detailClick(item)" [ngClass]="{'detail-link-text':i===0}"
                    *ngIf="item?.label!=='All'"> {{item?.label}} </span>
                <span class="gt">&gt;</span>
            </span>
        </div>
    </div>
    <div class="time-picker-container" [ngClass]="{'showTimeContainer':showTimePicker}">

        <app-dashboard-date-filter [initialValues]="emitData.timeFilter" [disabledSelection]="[]"
            (filterValues)="appliedFilters($event)"></app-dashboard-date-filter>

        <div class="button-container">
            <button mat-button type="button" class="cancel-btn" (click)="showHideTImeFilter('cancel')">{{'common.cancel'
                | translate}}
            </button>
            <button mat-button class="cancel-btn" [disabled]="!enableApplyBtn" type="button"
                (click)="showHideTImeFilter('ok')">{{'common.ok' | translate}}
            </button>
        </div>
    </div>
</div>

<div class="overlay-time fw fh" (click)="showTimePicker=false" [ngClass]="{'show':showTimePicker}"
    *ngIf="showTimePicker" (keydown.enter)="showTimePicker=false" (keydown.space)="showTimePicker=false">
</div>